// Fast-completion event bus + settings helpers.
// Decouples whoever finishes a fast (Timer, BackdateSheet, Log editor)
// from the UI that displays the completion ritual modal.

const SETTINGS_KEY = "monolith.settings";

export interface CompletionSettings {
  completion_popup_enabled: boolean;
  completion_atmosphere_enabled: boolean;
  completion_benefit_enabled: boolean;
  completion_popup_min_duration: number; // minutes
}

export const DEFAULT_COMPLETION_SETTINGS: CompletionSettings = {
  completion_popup_enabled: true,
  completion_atmosphere_enabled: true,
  completion_benefit_enabled: true,
  completion_popup_min_duration: 60, // don't pop for <1h
};

export function getCompletionSettings(): CompletionSettings {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return DEFAULT_COMPLETION_SETTINGS;
    const parsed = JSON.parse(raw) ?? {};
    return { ...DEFAULT_COMPLETION_SETTINGS, ...parsed };
  } catch {
    return DEFAULT_COMPLETION_SETTINGS;
  }
}

export interface FastCompletedDetail {
  sessionId?: string;
  startedAt: number;
  endedAt: number;
  durationMinutes: number;
  goalMinutes: number;
  goalMet: boolean;
  interrupted?: boolean;
  source: "timer-stop" | "log-past" | "log-edit";
}

export const FAST_COMPLETED_EVENT = "monolith:fast-completed";

export function emitFastCompleted(detail: FastCompletedDetail) {
  try {
    window.dispatchEvent(new CustomEvent<FastCompletedDetail>(FAST_COMPLETED_EVENT, { detail }));
  } catch {
    // no-op
  }
}

/** True if the completion modal should appear for this fast. */
export function shouldShowCompletionModal(detail: FastCompletedDetail): boolean {
  const s = getCompletionSettings();
  if (!s.completion_popup_enabled) return false;
  if (detail.durationMinutes < s.completion_popup_min_duration) return false;
  return true;
}
